module.exports = __webpack_public_path__ + "static/media/stockStep05.85e0bb92.png";